import React from "react";

const SidebarDivider = ({
  isHorizontal = true,
}: {
  isHorizontal?: boolean;
}) => {
  return (
    <div
      id="tabs"
      className={`flex ${isHorizontal ? "border-t" : "m-1 border-r"} my-2 space-y-1 border-t border-gray-300 dark:border-cubeBaseDark-600 `}
    ></div>
  );
};

export default SidebarDivider;
